import { query } from '@angular/animations';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConstants } from 'src/app/constants/app.constant';
import { LocalStorage } from './localStorage';

@Injectable({
  providedIn: 'root',
})
export class HttpHelper {
  protected localStorage: LocalStorage;

  constructor(private http: HttpClient) {
    this.localStorage = AppConstants.injector.get(LocalStorage);
  }

  async get<T>(
    url: string,
    headers: HttpHeaders,
    queryParams?: any
  ): Promise<T> {
    return await this.http
      .get<T>(url, { headers: headers, params: queryParams })
      .toPromise()
      .then((res) => {
        return res;
      })
      .catch((o) => {
        return o.error;
      });
  }

  getObservable<T>(
    url: string,
    headers: HttpHeaders,
    queryParams?: any
  ): Observable<T> {
    return this.http.get<T>(url, { headers: headers, params: queryParams });
  }

  async post<T>(
    url: string,
    headers: HttpHeaders,
    body?: any,
    queryParams?: any
  ): Promise<T> {
    return await this.http
      .post<T>(url, body, { headers: headers, params: queryParams })
      .toPromise()
      .then((res) => {
        return res;
      })
      .catch((o) => {
        return o.error;
      });
  }

  postObservable<T>(
    url: string,
    headers: HttpHeaders,
    body?: any,
    queryParams?: any,
    type?: any
  ): Observable<T> {
    return this.http.post(url, body, { headers: headers, params: queryParams, observe: 'response', responseType: type}).pipe(
      map((res: any) => res.body),
    );
  }

  async put<T>(
    url: string,
    headers: HttpHeaders,
    body?: any,
    queryParams?: any
  ): Promise<T> {
    return await this.http
      .put<T>(url, body, { headers: headers, params: queryParams })
      .toPromise()
      .then((res) => {
        return res;
      })
      .catch((o) => {
        return o.error;
      });
  }

  async patch<T>(
    url: string,
    headers: HttpHeaders,
    body?: any,
    queryParams?: any
  ): Promise<T> {
    return await this.http
      .patch<T>(url, body, { headers: headers, params: queryParams })
      .toPromise()
      .then((res) => {
        return res;
      })
      .catch((o) => {
        return o.error;
      });
  }

  async delete<T>(
    url: string,
    headers: HttpHeaders,
    body?: any,
    queryParams?: any
  ): Promise<T> {
    headers = new HttpHeaders();
    let accessToken = localStorage.getItem('accessToken')?.toString();
    const httpOptions = {
      headers: new HttpHeaders()
        .append('Content-type', 'application/json')
        .set('Authorization', accessToken ? accessToken : ''),
      params: queryParams,
      body: body,
    };

    return await this.http
      .delete<T>(url, httpOptions)
      .toPromise()
      .then((res) => {
        return res;
      })
      .catch((o) => {
        return o.error;
      });
  }
}
